import { useEffect, useState } from "react"

const useLongFormFromSession = (defaultLongForm: boolean) => {
  const [hasLongForm, setHasLongForm] = useState(defaultLongForm)

  useEffect(() => {
    const handleStorageChange = () => {
      const storedValue = sessionStorage.getItem("hasLongForm")
      if (storedValue === "true") {
        setHasLongForm(true)
      } else if (storedValue === "false") {
        setHasLongForm(false)
      }
    }
    window.addEventListener("session-storage-change", handleStorageChange)
    return () => {
      window.removeEventListener("session-storage-change", handleStorageChange)
    }
  }, [])

  return hasLongForm
}

export default useLongFormFromSession
